import {createViewerScript} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/createViewerScript';

export const controllersConfig = createViewerScript(null, {useWorkerRaven: true});
